var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReuploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25285_14881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.10831 3.54487L2.683 10.9326C2.59176 11.0906 2.54348 11.2697 2.54297 11.4522C2.54246 11.6346 2.58973 11.814 2.68009 11.9726C2.77044 12.1311 2.90073 12.2632 3.05798 12.3557C3.21523 12.4482 3.39397 12.498 3.57642 12.5H12.427C12.6095 12.498 12.7882 12.4482 12.9455 12.3557C13.1027 12.2632 13.233 12.1311 13.3234 11.9726C13.4137 11.814 13.461 11.6346 13.4605 11.4522C13.46 11.2697 13.4117 11.0906 13.3205 10.9326L8.89515 3.54487C8.80201 3.39132 8.67086 3.26437 8.51437 3.17626C8.35788 3.08816 8.18132 3.04187 8.00173 3.04187C7.82214 3.04187 7.64558 3.08816 7.48908 3.17626C7.33259 3.26437 7.20145 3.39132 7.10831 3.54487Z",
    fill: "#6E6E84",
    stroke: "#6E6E84",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 5.724V8.26454M8 10.8724V10.9733",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25285_14881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReuploadIcon);
export default __webpack_public_path__ + "static/media/reupload-icon.ff891c9f.svg";
export { ForwardRef as ReactComponent };